import $ from "jquery";
/**
 * The attachments browser selector used across media library hooks.
 */ const BROWSER_SELECTOR = ".attachments-browser";
/**
 * Resolved when the first attachments browser toolbar with the RML filter is created.
 */ const firstCreatedToolbar = $.Deferred();
export { BROWSER_SELECTOR, firstCreatedToolbar };
